/**
 * EmptyState Component
 * Reusable empty state display with icon, title, description, and optional action
 */

import type { LucideIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

interface EmptyStateProps {
	icon: LucideIcon;
	title: string;
	description: string;
	actionLabel?: string;
	onAction?: () => void;
	className?: string;
}

export function EmptyState({
	icon: Icon,
	title,
	description,
	actionLabel,
	onAction,
	className,
}: EmptyStateProps) {
	return (
		<Card className={`p-12 text-center ${className ?? ""}`}>
			<div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-muted">
				<Icon className="h-8 w-8 text-muted-foreground" />
			</div>
			<h3 className="mt-4 text-lg font-semibold text-foreground">{title}</h3>
			<p className="mt-2 text-sm text-muted-foreground">{description}</p>
			{actionLabel && onAction && (
				<Button variant="primary" onClick={onAction} className="mt-6">
					{actionLabel}
				</Button>
			)}
		</Card>
	);
}
